import React from 'react';
import type { User } from '@supabase/supabase-js';
import { UsernameModal } from './UsernameModal';

interface Props {
  user: User;
  onComplete: () => void;
}

/**
 * Gate global: se o profile do user logado não tem `username`, mostra modal
 * bloqueante. Cobre tanto usuários novos quanto migrados.
 */
export function UsernameGate({ user, onComplete }: Props) {
  return <UsernameModal user={user} onComplete={onComplete} />;
}
